/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';

// redux
import { useSelector } from 'react-redux';
// material
import { Page, Content } from '@insticator/insticator-ui';
import PageHeader from "../../../../material/structure/pageheader/pageheader";
import PageContent from "../../../../material/structure/pagecontent/pagecontent";

// styles
import injectSheet from "react-jss";
import ApiAccessPage from "./apiaccesss/apiaccess";

/* ========== ~~~~~~~~~~ DEVELOPER TOOLS PAGE ~~~~~~~~~~ ========== */
const DeveloperToolsPage = injectSheet()((props) => {
    return (
        <Page>
            <Content>
                <PageHeader title={'Settings'} subtitle={'Developer Tools'} />
                <PageContent>
                    <ApiAccessPage></ApiAccessPage>
                </PageContent>
            </Content>
        </Page>
    )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default DeveloperToolsPage;
